import { DeepMap } from 'react-hook-form';
import { JobsiteUpdateInput } from 'apollo/generated/client-operations';
import { ensureNonUndefinedFields } from 'utils';
import { FormInputTypes, TypedFormInputs } from 'components/form';
import { EditJobsiteConfigurationFormData } from 'containers/jobsiteConfiguration/types';
import { Jobsite } from './types';
import {
  procoreSectionInputs,
  getProcoreSectionDefaultValues,
  getProcoreSectionUpdateInput,
} from './procoreSection';

export type EditJobsiteConfigTabFormData = Pick<
  EditJobsiteConfigurationFormData,
  'procore'
>;

export const getFormInputs =
  (): TypedFormInputs<EditJobsiteConfigTabFormData> => {
    return {
      procore: {
        element: FormInputTypes.Section,
        layout: '',
        elementProps: {
          title: 'Procore',
        },
        children: procoreSectionInputs,
      },
    };
  };

type GetDefaultValuesArgs = {
  jobsite: Jobsite;
};

export const getDefaultValues = (
  args: GetDefaultValuesArgs,
): EditJobsiteConfigTabFormData => {
  const { jobsite } = args;
  const procore = getProcoreSectionDefaultValues(jobsite);
  return { procore };
};

export const getJobsiteUpdateInput = (
  jobsite: Jobsite,
  data: EditJobsiteConfigTabFormData,
  dirtyFields: DeepMap<EditJobsiteConfigTabFormData, true>,
): JobsiteUpdateInput => {
  return ensureNonUndefinedFields<JobsiteUpdateInput>({
    jobsiteId: jobsite.jobsiteId,
    ...getProcoreSectionUpdateInput(data.procore, dirtyFields.procore),
  });
};
